import React, { useState } from 'react';
import { Card, CardMedia, CardContent, CardActions, Typography, IconButton} from '@material-ui/core';
import {AddShoppingCart} from '@material-ui/icons';
import Progress from '../../MySpinner/MySpinner'
import useStyles from './styles'

// name, media, description, price
//source, formatted_with_symbol

const Product = ({id, name, description, price, media, handleAdd}) => {
    const classes = useStyles();
    const [product, setProduct] = useState(false);

    const add = async (id) => {
        setProduct(true);
        await handleAdd(id, 1)
        setProduct(false);
    }

    return (
        <Card className = {classes.root}>
            <CardMedia className = {classes.media} image = {media.source} title = {name}/>
            
            <CardContent >
                <div className = {classes.cardContent}>
                    <Typography className={classes.name} variant = "subtitle2" gutterBottom>
                        {name}
                    </Typography>
                    <Typography className={classes.price} variant = "subtitle2">
                        {price.formatted_with_symbol}
                    </Typography>
                </div>

                <Typography className={classes.description} variant = "body2" color = "textSecondary" dangerouslySetInnerHTML = {{__html: description}}>
                </Typography>
            </CardContent>

            <CardActions disableSpacing className = {classes.cardActions}>
                <IconButton aria-label = "Add to Cart" className = {classes.cardIcon} onClick = {async () => await add(id)}>
                    {
                        product ? (
                            <Progress />
                        ) : (
                            <AddShoppingCart/>
                        )
                    }
                </IconButton>
            </CardActions>
        </Card>
    )
}

export default Product
